import(/* webpackMode: "eager" */ "/usr/src/app/applicant-portal/src/app/[lang]/onboarding/layout.tsx")